// ShortsCategoriesCategory.jsx
import React from 'react';
import { useLoaderData } from 'react-router';

import DiscoverShowMoreWrapper from '../component/DiscoverShowMoreWrapper.jsx';
import { createCategoryLoader } from '../resource/createCategoryLoader.js';
import useSSRDataMerge from '../hook/useSSRDataMerge.js';

export const loader = createCategoryLoader({
  pathPrefix: 'shorts-categories',
  categoryType: 'shorts',
  loaderName: 'ShortsCategoriesCategory',
});

const ShortsCategoriesCategoryRoute = () => {
  const { data, error } = useLoaderData();

  useSSRDataMerge({
    componentName: 'ShortsCategoriesCategory',
    loaderData: data,
    loaderError: error,
  });

  return <DiscoverShowMoreWrapper isShorts />;
};

export default ShortsCategoriesCategoryRoute;
